import React from 'react';
import arrow from '../../../images/icons/ic-arrow.svg';
import ProfilePicture from '../../Athletes/ProfilePicture';

const AthleteSearchItem = ({ athlete }) => {
  return (
    <a
      href={athlete.url}
      className='flex justify-between w-full border-b border-border-secondary last:border-none px-4 md:px-6 py-12pt hover:bg-background-quinary'
    >
      <div className='flex flex-1 items-center min-w-0'>
        <ProfilePicture
          avatar={athlete.avatar_url}
          avatar_text={athlete.avatar_text}
          avatar_theme={athlete.avatar_theme}
          sizeClassName='w-[2.5rem] h-[2.5rem]'
          spacingClassName='mr-3 shrink-0'
        />
        <div className='min-w-0'>
          <h5 className='truncate m-0 mt-4pt font-text body-text'>
            {athlete.name}
          </h5>
        </div>
      </div>
      <div className='flex items-center'>
        <span>
          <img src={arrow} className='w-4' alt='' />
        </span>
      </div>
    </a>
  );
};

export default AthleteSearchItem;
